import ApiClient from './apiclient';

let operators = null;

let OperatorDataProvider = {

    loadOperators: async function () {
        if (operators) {
            return operators;
        }

        operators = await ApiClient.loadOperators();
        return operators;
    }
}

export default OperatorDataProvider;